import { HowToWorkPage } from "../HowToWorkPage"
import { distributorConfig } from "../configs/distributor.config"

export function HowToWorkDistributor() {
    return <HowToWorkPage config={distributorConfig} />
}
